import { useTranslation } from 'react-i18next'
import InputField from '../../../../../../components/formFields/InputField'
import SectionCard from '../shared/SectionCard'
import './style.css'
import GeoLocPicker from '@comp/GoogleGeoLoc'

const EditContactInformation = ({ formHandler, providerInfo, isLoading }) => {
    const { t } = useTranslation()

    return (
        <SectionCard
            title={t("contact-details")}
            icon="teenyicons:contact-solid"
            className="edit-contact-info"
        >
            <div className="row">
                <InputField
                    formHandler={formHandler}
                    name={"phoneNumber"}
                    label={"phoneNumber"}
                    isLoading={isLoading}
                    type="tel"
                    defaultValue={providerInfo?.phoneNumber}
                />


                <InputField
                    formHandler={formHandler}
                    name={"email"}
                    label={"email"}
                    isLoading={isLoading}
                    type="email"
                    defaultValue={providerInfo?.email}
                    lang="any"
                />
                <InputField
                    formHandler={formHandler}
                    name={"websiteUrl"}
                    label={"websiteUrl"}
                    isLoading={isLoading}
                    type="url"
                    defaultValue={providerInfo?.websiteUrl}
                    isRequired={false}
                    lang="any"
                />
                <InputField
                    formHandler={formHandler}
                    name={"SLA"}
                    label={"SLA"}
                    isLoading={isLoading}
                    type="number"
                    defaultValue={providerInfo?.sla}
                />
                <GeoLocPicker
                    setLink={(link) => formHandler.handleFormValues("googleMapLink", link)} initialLocation={providerInfo?.location} />

            </div>
        </SectionCard>
    )
}

export default EditContactInformation

